import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShredder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShredder"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V10H4V2ZM2 12H22V13.5H2V12ZM6.5 15.5V19.9444H5V15.5H6.5ZM10.6667 15.5V22H9.16667V15.5H10.6667ZM14.8333 15.5V19.9444H13.3333V15.5H14.8333ZM19 15.5V22H17.5V15.5H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShredder;
